import type {
	FormValues,
	NormalizedFormValues,
	SignFormExperiments,
} from 'src/app/pages/petitionGamma/details/shared/types';

export function normalizeSmsCommsConsent(
	{ smsCommsConsentGiven }: Pick<FormValues, 'smsCommsConsentGiven'>,
	{ mobileOptIn }: SignFormExperiments,
): NormalizedFormValues['smsCommsConsent'] {
	return mobileOptIn.showOptInCheckbox && mobileOptIn.optInChannel === 'sms'
		? {
				consentGiven: !!smsCommsConsentGiven,
				// phone_consent is in the user_service prefix safelist
				name: 'phone_consent_sign_form_sms_updates',
				text: mobileOptIn.optInCopy,
			}
		: null;
}
